import { create } from 'zustand';
import type { GameScreen } from '@/game/types';
import { HIGH_SCORE_KEY } from '@/game/constants';
import { trackPlay, trackMatch, emitGameEvent, startLooplayAttempt } from '@/looplay';
interface GameStore {
  screen: GameScreen;
  score: number;
  highScore: number;
  sessionStartMs: number | null;
  matchId: string | null;
  setScreen: (screen: GameScreen) => void;
  setScore: (score: number) => void;
  startGame: () => void;
  endGame: (finalScore: number) => void;
}
const loadHighScore = (): number => {
  try {
    return parseInt(localStorage.getItem(HIGH_SCORE_KEY) ?? '0', 10) || 0;
  } catch {
    return 0;
  }
};
const saveHighScore = (score: number): void => {
  try {
    localStorage.setItem(HIGH_SCORE_KEY, String(score));
  } catch {
    // ignore
  }
};
const generateMatchId = () =>
  `match_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
export const useGameStore = create<GameStore>((set, get) => ({
  screen: 'lobby',
  score: 0,
  highScore: loadHighScore(),
  sessionStartMs: null,
  matchId: null,
  setScreen: (screen) => set({ screen }),
  setScore: (score) => set({ score }),
  startGame: () => {
    const matchId = generateMatchId();
    set({
      screen: 'playing',
      score: 0,
      sessionStartMs: Date.now(),
      matchId,
    });
    void startLooplayAttempt();
    void emitGameEvent('GAME_STARTED');
  },
  endGame: (finalScore) => {
    const { highScore, sessionStartMs, matchId } = get();
    const durationSeconds = sessionStartMs
      ? Math.floor((Date.now() - sessionStartMs) / 1000)
      : 0;
    const isNewHigh = finalScore > highScore;
    const nextHighScore = isNewHigh ? finalScore : highScore;
    if (isNewHigh) {
      saveHighScore(finalScore);
    }
    set({
      screen: 'gameover',
      score: finalScore,
      highScore: nextHighScore,
      sessionStartMs: null,
      matchId: null,
    });
    void trackPlay(durationSeconds);
    if (matchId) {
      void trackMatch(matchId, {
        durationSeconds,
        isCompleted: true,
        isWin: false,
      });
    }
    void emitGameEvent('GAME_OVER', { value: finalScore });
    if (isNewHigh) {
      void emitGameEvent('HIGH_SCORE', { value: finalScore });
    }
  },
}));